import { Reveal, Eyebrow } from "@/components/Reveal";
import { Seal } from "@/components/Seal";

const ASSET = "https://customer-assets-wrfwihn1.emergentagent.net/job_sanzone-launch/artifacts";

const FRAMES = [
  {
    src: `${ASSET}/sel615mg_image.png`,
    alt: "The Kourier Kore Jacket by SANZONE — hand-painted one-of-one blazer, front and back, with a wolf graphic",
    caption: "The Kourier Kore Jacket — One of One",
  },
  {
    src: `${ASSET}/74mz2s97_image.png`,
    alt: "SANZONE one-of-one custom sneakers in textured gold with red laces on a black marble plinth",
    caption: "Wearable Art — Footwear Study",
  },
  {
    src: `${ASSET}/z6h0a9c1_image.png`,
    alt: "Model wearing a SANZONE hand-embellished fur jacket with red and gold striping — Instinct. Refined.",
    caption: "Instinct. Refined. — Embellished Fur",
  },
  {
    src: `${ASSET}/o4jb8b60_image.png`,
    alt: "SANZONE hand-painted suit, front and back, with stencil artwork on the jacket back",
    caption: "Hand-Painted Suit — Front & Back",
  },
  {
    src: `${ASSET}/l4kx0hyo_image.png`,
    alt: "Model wearing a SANZONE one-of-one couture sleeveless textured dress in a gilded interior",
    caption: "One-of-One Couture — In Situ",
  },
];

const Frame = ({ frame, index, hidden }) => (
  <figure className="group w-[68vw] shrink-0 sm:w-[400px]" aria-hidden={hidden || undefined}>
    <div className="relative overflow-hidden border border-[#221812]/15 transition-colors duration-500 group-hover:border-[#9A7B3F]/70">
      <img
        src={frame.src}
        alt={hidden ? "" : frame.alt}
        loading="lazy"
        className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        data-testid={hidden ? undefined : `lookbook-frame-0${index + 1}`}
      />
    </div>
    <figcaption className="font-code mt-4 text-[10px] uppercase tracking-[0.35em] text-[#8C857B] transition-colors duration-500 group-hover:text-[#5E1A22]">
      [{String(index + 1).padStart(3, "0")}/005] — {frame.caption}
    </figcaption>
  </figure>
);

export default function Lookbook() {
  return (
    <section className="relative overflow-hidden py-28 sm:py-36" data-testid="lookbook-section" aria-label="Lookbook — recent one-of-one works">
      <div className="mx-auto mb-14 flex max-w-7xl items-end justify-between gap-8 px-6 sm:px-12 lg:px-20">
        <div>
          <Reveal>
            <Eyebrow>[ 03 — The Archive — Recent Works ]</Eyebrow>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-[#55504A] sm:text-base">
              Real one-of-one pieces from the SANZONE studio. Shown for the craft — archive works are not for sale.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="hidden shrink-0 sm:block">
          <Seal />
        </Reveal>
      </div>
      <div className="animate-marquee-slow flex w-max gap-6 pl-6 sm:gap-10">
        {FRAMES.map((f, i) => (
          <Frame key={f.caption} frame={f} index={i} />
        ))}
        {FRAMES.map((f, i) => (
          <Frame key={`${f.caption}-dup`} frame={f} index={i} hidden />
        ))}
      </div>
    </section>
  );
}
